export var getLivenessDictionary = function (t) { return ({
    photosensitivyWarningHeadingText: t('livenessDetector.photosensitivityWarningHeadingText'),
    photosensitivyWarningInfoText: t('livenessDetector.photosensitivityWarningInfoText'),
    photosensitivyWarningLabelText: t('livenessDetector.photosensitivityWarningLabelText'),
    photosensitivityWarningHeadingText: t('livenessDetector.photosensitivityWarningHeadingText'),
    photosensitivityWarningBodyText: t('livenessDetector.photosensitivityWarningBodyText'),
    photosensitivityWarningInfoText: t('livenessDetector.photosensitivityWarningInfoText'),
    photosensitivityWarningLabelText: t('livenessDetector.photosensitivityWarningLabelText'),
    goodFitCaptionText: t('livenessDetector.goodFitCaptionText'),
    goodFitAltText: t('livenessDetector.goodFitAltText'),
    tooFarCaptionText: t('livenessDetector.tooFarCaptionText'),
    tooFarAltText: t('livenessDetector.tooFarAltText'),
    hintCenterFaceText: t('livenessDetector.hintCenterFaceText'),
    hintCenterFaceInstructionText: t('livenessDetector.hintCenterFaceInstructionText'),
    hintFaceOffCenterText: t('livenessDetector.hintFaceOffCenterText'),
    hintMoveFaceFrontOfCameraText: t('livenessDetector.hintMoveFaceFrontOfCameraText'),
    hintTooManyFacesText: t('livenessDetector.hintTooManyFacesText'),
    hintFaceDetectedText: t('livenessDetector.hintFaceDetectedText'),
    hintCanNotIdentifyText: t('livenessDetector.hintCanNotIdentifyText'),
    hintTooCloseText: t('livenessDetector.hintTooCloseText'),
    hintTooFarText: t('livenessDetector.hintTooFarText'),
    hintConnectingText: t('livenessDetector.hintConnectingText'),
    hintVerifyingText: t('livenessDetector.hintVerifyingText'),
    hintCheckCompleteText: t('livenessDetector.hintCheckCompleteText'),
    hintIlluminationTooBrightText: t('livenessDetector.hintIlluminationTooBrightText'),
    hintIlluminationTooDarkText: t('livenessDetector.hintIlluminationTooDarkText'),
    hintIlluminationNormalText: t('livenessDetector.hintIlluminationNormalText'),
    hintHoldFaceForFreshnessText: t('livenessDetector.hintHoldFaceForFreshnessText'),
    hintMatchIndicatorText: t('livenessDetector.hintMatchIndicatorText'),
    startScreenBeginCheckText: t('livenessDetector.startScreenBeginCheckText'),
    cameraMinSpecificationsHeadingText: t('livenessDetector.cameraMinSpecificationsHeadingText'),
    cameraMinSpecificationsMessageText: t('livenessDetector.cameraMinSpecificationsMessageText'),
    cameraNotFoundHeadingText: t('livenessDetector.cameraNotFoundHeadingText'),
    cameraNotFoundMessageText: t('livenessDetector.cameraNotFoundMessageText'),
    a11yVideoLabelText: t('livenessDetector.a11yVideoLabelText'),
    cancelLivenessCheckText: t('livenessDetector.cancelLivenessCheckText'),
    retryCameraPermissionsText: t('livenessDetector.retryCameraPermissionsText'),
    recordingIndicatorText: t('livenessDetector.recordingIndicatorText'),
    waitingCameraPermissionText: t('livenessDetector.waitingCameraPermissionText'),
    errorLabelText: t('livenessDetector.errorLabelText'),
    connectionTimeoutHeaderText: t('livenessDetector.connectionTimeoutHeaderText'),
    connectionTimeoutMessageText: t('livenessDetector.connectionTimeoutMessageText'),
    timeoutHeaderText: t('livenessDetector.timeoutHeaderText'),
    timeoutMessageText: t('livenessDetector.timeoutMessageText'),
    faceDistanceHeaderText: t('livenessDetector.faceDistanceHeaderText'),
    faceDistanceMessageText: t('livenessDetector.faceDistanceMessageText'),
    multipleFacesHeaderText: t('livenessDetector.multipleFacesHeaderText'),
    multipleFacesMessageText: t('livenessDetector.multipleFacesMessageText'),
    clientHeaderText: t('livenessDetector.clientHeaderText'),
    clientMessageText: t('livenessDetector.clientMessageText'),
    serverHeaderText: t('livenessDetector.serverHeaderText'),
    serverMessageText: t('livenessDetector.serverMessageText'),
    landscapeHeaderText: t('livenessDetector.landscapeHeaderText'),
    landscapeMessageText: t('livenessDetector.landscapeMessageText'),
    portraitMessageText: t('livenessDetector.portraitMessageText'),
    tryAgainText: t('livenessDetector.tryAgainText'),
}); };
